import { mapReferenceToPath } from '@framework/engine/schema/expressions/evaluate/mapReferenceToPath.ts';
import { createEvaluationVariables } from '@framework/engine/schema/expressions/evaluate/variables/IEvaluationVariables.ts';
import { type ICreateWidgetFormSchemaInput } from '@framework/engine/schema/widgets/IWidgetType.ts';
import { FormBuilderMetaFlags } from '@framework/engine/validator/form-builder/flags/FormBuilderMetaFlags.ts';
import { yup } from '@framework/validation/initYup.ts';
import {
  CompetenceMetaFlag,
  CompetenceSecondaryMetaFlag,
  CompetenceSecondaryTypeIdMetaKey,
  CompetenceSource,
  CompetenceSourceMetaKey,
} from './competenceMetaFlags.ts';
import { type ICompetenceWidget } from './ICompetenceWidget.ts';

export function competenceSelectWidgetLabelName(code: string) {
  return `${code}@label`;
}

export function createCompetenceSelectFormSchema(
  input: ICreateWidgetFormSchemaInput<ICompetenceWidget>,
) {
  const { widget } = input;

  const reference = widget.sourceValueReference;

  let widgetSchema = yup.string().meta({
    [CompetenceMetaFlag]: true,
    [CompetenceSecondaryMetaFlag]: widget.isExtraCompetence ?? false,
    [CompetenceSourceMetaKey]: CompetenceSource.Widget,
    [CompetenceSecondaryTypeIdMetaKey]: widget.secondaryCompetenceTypeId,
  });

  // Se è richiesta la reference, impostiamo forzatamente il valore del campo
  if (reference) {
    const path = mapReferenceToPath(reference);
    widgetSchema = widgetSchema.parentWhen(
      [path],
      (values, schema: yup.AnySchema, context: any) => {
        const variables = createEvaluationVariables([reference], values);
        const value = variables[reference.id];
        return schema.default(value ?? null).transform(() => value);
      },
    );
  }

  const labelSchema = yup
    .string()
    .notRequired()
    .formBuilderFlags(
      FormBuilderMetaFlags.SkipDefaultValue,
      FormBuilderMetaFlags.SkipValidationRules,
    );

  return {
    [widget.code]: widgetSchema.notRequired(),
    [competenceSelectWidgetLabelName(widget.code)]: labelSchema.notRequired(),
  };
}
